import moment from "moment";

export function parseMissingStatusFilter(filterValue) {
  if (!filterValue) {
    return null;
  }

  try {
    return JSON.parse(filterValue);
  } catch (_error) {
    return null;
  }
}

export function getMissingStatusDateParams(filterValue) {
  const filter = parseMissingStatusFilter(filterValue);

  return {
    filter,
    startDate: filter ? moment(filter.startDate).format("YYYY-MM-DD") : "",
    endDate: filter ? moment(filter.endDate).format("YYYY-MM-DD") : "",
  };
}

export function getDateRangeHeading(filter) {
  return filter
    ? `${moment(filter.startDate).format("MM/DD/YYYY")} - ${moment(
        filter.endDate
      ).format("MM/DD/YYYY")}`
    : "Select Date Range";
}

export function getInitialSelectionRange(filter) {
  if (filter) {
    return [
      {
        startDate: new Date(filter.startDate),
        endDate: new Date(filter.endDate),
        key: "selection",
      },
    ];
  }

  return [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ];
}

export function formatMissingStatusRows(data = []) {
  return data.map((item, index) => ({
    ...item,
    id: index + 1,
    notes: `${item.leave_type ? item.leave_type : "none"}${
      item.reason ? ` : ${item.reason}` : ""
    }`,
  }));
}

export function getGroupedUsers(groupingUser = []) {
  return groupingUser.map((item) => item.users).flat();
}

export function filterMissingStatusByUsers(data = [], groupingUser = []) {
  const selectedUsers = groupingUser?.[0]?.users || [];

  if (selectedUsers.length === 0) {
    return data;
  }

  return data.filter((item) =>
    selectedUsers.some((user) => user?.user_id === item?.user_id)
  );
}

export function formatMissingStatusCsvRows(data = []) {
  return data.map((item) => ({
    "User name": item.username,
    Date: moment(item.date).format("DD/MM/YYYY"),
    Delay: item.delay || "-",
    "Hour spent": `${item.total_hours_spent}/8`,
    Notes: `${item.leave_type ? item.leave_type : "none"}${
      item.reason ? ` : ${item.reason}` : ""
    }`,
  }));
}
